// Module
var code = "<div class=\"col-sm-4 text-center\">\n  <h4 translate ng-if=\"view !== 'member_edit'\">{{'app.shared.wallet.your_wallet_amount'}}</h4>\n  <h4 translate ng-if=\"view === 'member_edit'\">{{'app.shared.wallet.wallet_amount'}}</h4>\n  <div class=\"wallet-amount-container\">\n    <div class=\"wallet-amount\">{{wallet.amount | currency}}</div>\n  </div>\n</div>\n";
// Exports
var _module_exports = code;;
var path = '/wallet/show.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;